import { encode, decode } from 'js-base64';
import type { Attachment, AttachmentId } from "../types"

export const decodeAttachmentId = (attachmentId: AttachmentId): Attachment => {
    const [id, ...fileName] = attachmentId.split('_') as [Attachment["id"], Attachment["fileName"]];
    return { id, fileName: decode(fileName.join('_')) };
}

export const encodeAttachmentId = (id: Attachment["id"], fileName: Attachment["fileName"]): AttachmentId => 
    `${id}_${encode(fileName)}`